/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt } from '../../twd/twd'
import Empty from './empty'
import Foot from './foot'

export default ({rows}) => <React.Fragment>
    {(!rows || rows.length===0) && Empty({msg:'There are no historical rating actions since 9/30/2011'})}

    {rows && rows.length>0 && <div className="table-responsive">
    <table
        data-name="bond-detail-events-ratings-credit-rating-actions-table"
        className="table table-striped align-top">
    <thead>
        <tr>
        <th style={{borderBottom:0}}></th>
        <th style={{borderBottom:0,fontWeight:500,color:'#242424'}} colSpan="3" className="text-center">Moody's Ratings Actions</th>
        <th style={{borderBottom:0,fontWeight:500,color:'#242424'}} colSpan="3" className="text-center">S&P Ratings Actions</th>
        </tr>
        <tr>
        <th style={{borderTop:0, borderRight:'1px solid #e4e4e4'}}>Action Date</th>
        <th style={{borderTop:0}}>Long Term</th>
        <th style={{borderTop:0}}>Watch/Outlook</th>
        <th style={{borderTop:0, borderRight:'1px solid #e4e4e4'}}>Underlying</th>
        <th style={{borderTop:0}}>Long Term</th>
        <th style={{borderTop:0}}>Watch/Outlook</th>
        <th style={{borderTop:0}}>Underlying</th>
        </tr>
    </thead>
    <tbody>{
        rows.map( (r,i) => {
            return <tr
                data-name="bond-detail-events-ratings-credit-rating-actions-row"
                key={i}>
            <td style={{borderRight:'1px solid #e4e4e4'}}>{fmt.mdy(r.creditRatingDate)}</td>
            <td>{trend(r.moodyLtTrend)}{r.moodyLtRating}</td>
            <td>{r.moodyWatchOutlook || '-- / --'}</td>
            <td style={{borderRight:'1px solid #e4e4e4'}}>{trend(r.moodyUndTrend)} {r.moodyUndRating}</td>
            <td>{trend(r.spLtTrend)}{r.spLtRating}</td>
            <td>{r.spWatchOutlook || '-- / --'}</td>
            <td>{trend(r.spUndTrend)} {r.spUndRating}</td>
            </tr>
        })
    }</tbody>
    </table>
    </div>}

    <Foot label='Credit Ratings Actions' />
</React.Fragment>

let trend = (value) => <span
    aria-hidden="true"
    style={{
        width: '15px',
        display: 'inline-block',
        color: value==='D' ? '#cc0000' :
            value==='U' ? '#107A1B' :
            'transparent'
    }}

    dangerouslySetInnerHTML={{
        __html: value === 'D' ? '&#9660;' :
            value === 'U' ? '&#9650;' :
            ''
    }}
    ></span>


// WEBPACK FOOTER //
// ./src/bond-detail/events/credit-rating-actions.js